// extracted by mini-css-extract-plugin
export default {"list":"OurServices_list__c5kPS"};